// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mestable-pagination[data-v-3c476f82], .el-pagination[data-v-3c476f82]  {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.mestable-pagination .el-pagination__sizes[data-v-3c476f82], .el-pagination[data-v-3c476f82]  .el-pagination__sizes {\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n}", ""]);
// Exports
module.exports = exports;
